import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { collection, getDoc, doc, setDoc, getDocs, writeBatch } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import { saveUserLog } from './LogandUtils'; // 경로에 맞게 수정
import styleClasses from './css/MyPage.module.scss';

function PushPosition() {
  // URL에서 "positionId" 파라미터를 읽어와 배열로 변환 (없으면 빈 배열)
  const [searchParams] = useSearchParams();
  const positionIdsParam = searchParams.get('positionId'); 
  const positionIds = positionIdsParam ? positionIdsParam.split(',') : [];
  
  const navigate = useNavigate();
  const user = auth.currentUser;
  
  const [musicards, setMusicards] = useState([]);
  const [selectedMusicard, setSelectedMusicard] = useState('');

  useEffect(() => {
    if (!user) {
      console.error("사용자가 로그인되어 있지 않습니다.");
      navigate('/login');
      return;
    }

    // 사용자의 musicard 필드 중 key에 solo가 포함된 항목만 가져옴
    const fetchMusicards = async () => {
      try {
        const userDocSnap = await getDoc(doc(db, "users", user.uid));
        if (userDocSnap.exists()) {
          const userData = userDocSnap.data();
          const soloMusicardList = Object.entries(userData.musicard || {})
            .filter(([key]) => key.toLowerCase().includes('solo'))
            .map(([key, value]) => ({
              id: key,
              name: value,
            }));
          setMusicards(soloMusicardList);
        } else {
          console.error("사용자 문서가 존재하지 않습니다.");
        }
      } catch (error) {
        console.error("뮤지카드 가져오기 오류:", error);
      }
    };

    fetchMusicards();
  }, [user, navigate]);

  const handleSubmit = async () => {
    if (!selectedMusicard || positionIds.length === 0) {
      alert("뮤지카드와 포지션을 선택해주세요.");
      return;
    }
  
    try {
      // 선택된 각 positionId에 대해 작업 수행
      for (const positionId of positionIds) {
        // 1. users_data에서 해당 포지션 데이터를 가져오기 (컬렉션 경로: users_data/[UID]/positions)
        const userPositionRef = doc(db, `users_data/${user.uid}/positions`, positionId);
        const positionSnap = await getDoc(userPositionRef);
        if (!positionSnap.exists()) {
          alert(`복사할 포지션 데이터를 찾을 수 없습니다: ${positionId}`);
          continue; // 없는 경우 건너뛰기
        }
        const positionData = positionSnap.data();

        // 2. 가져온 포지션 데이터에 positionId, ownerId 추가하여 musicians 컬렉션에 저장
        // 여기서는 대상 경로를 musicians/[선택한뮤지카드]/positions/[positionId]로 설정
        const musicianPositionRef = doc(db, `musicians/${selectedMusicard}/positions`, positionId);
        await setDoc(musicianPositionRef, {
          ...positionData,
          positionId,
          ownerId: user.uid,
        }, { merge: true });

        // 3. users_data의 해당 포지션의 skills 하위 컬렉션을 musicians의 포지션 하위 컬렉션으로 복사
        const sourceSkillsRef = collection(db, `users_data/${user.uid}/positions/${positionId}/skills`);
        const skillsSnapshot = await getDocs(sourceSkillsRef);
        const batch = writeBatch(db);
        skillsSnapshot.forEach((skillDoc) => {
          const skillData = skillDoc.data();
          const destSkillRef = doc(db, `musicians/${selectedMusicard}/positions/${positionId}/skills`, skillDoc.id);
          batch.set(destSkillRef, skillData);
        });
        await batch.commit();

        const changedPaths = [musicianPositionRef.path, sourceSkillsRef.path];
        await saveUserLog('musicard_logs', selectedMusicard, 'create', changedPaths, 'PushPosition');

        // 4. users_data의 해당 포지션 문서에서 act 필드를 업데이트 (기존 act와 병합)
        await setDoc(userPositionRef, {
          act: {
            [selectedMusicard]: positionId
        }
        }, { merge: true });
      }
  
      alert("뮤지카드에 선택한 포지션들이 추가되었습니다!");
      navigate("/my-page/position-skill");
    } catch (error) {
      console.error("포지션 추가 오류:", error);
      alert("포지션 추가 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className={styleClasses.pushPage}>
      <h1>뮤지카드로 포지션 내보내기</h1>
      <p>솔로 뮤지션 유형 뮤지카드에만 내보낼 수 있습니다.</p>
      <div className={styleClasses.form}>
        <label>내 뮤지카드 선택</label>
        <select value={selectedMusicard} onChange={(e) => setSelectedMusicard(e.target.value)}>
          <option value="">뮤지카드를 선택하세요</option>
          {musicards.map((card) => (
            <option key={card.id} value={card.name}>
              {card.name}
            </option>
          ))}
        </select>

        <button onClick={handleSubmit} className="primaryButton">
          포지션 내보내기
        </button>
      </div>
    </div>
  );
}

export default PushPosition;